import styled from 'styled-components'

const Label = styled.span`
  color: #808191;
`
export default Label
